import { render, staticRenderFns } from "./PainelGestaoLogisticaSustentavel.vue?vue&type=template&id=0b3138cc"
import script from "./PainelGestaoLogisticaSustentavel.vue?vue&type=script&lang=js"
export * from "./PainelGestaoLogisticaSustentavel.vue?vue&type=script&lang=js"
import style0 from "./PainelGestaoLogisticaSustentavel.vue?vue&type=style&index=0&id=0b3138cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports